import { AxiosResponse } from 'axios';

import { api } from 'tools/api-service';

import { PostSubscriptionResponse } from './types/post-subscription.type';

export const postSubscription = async (
    url: string
): Promise<AxiosResponse<PostSubscriptionResponse>> => {
    const apiUrl = url.replace('/web3/api', '');

    const response = await api.post(apiUrl);

    return response;
};
